const mutations = {

    // set the direction of navigation
    setPageDirection: (state, payload) => state.navigationDirection = payload,
    setActiveContent: (state, payload) => state.activeContent = payload,
    setCurrentPage: (state, payload) => state.currentPage = payload,
    setReadingContent: (state, payload) => state.readingContent = payload,
    setNavigatingPages: (state, payload) => state.navigatingPages = payload,
    setCloseContent: (state, payload) => state.closeContent = payload,
    setManagingCookies: (state, payload) => state.managingCookies = payload

};

export default mutations;